import CIcon from "@coreui/icons-react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CCollapse,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCallResponse, apiCallSPGet } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { formatDate } from "src/shared/Format/dateFormat";
import { SCSelect } from "src/views/common/CommonSearch";
const LotLink = ({ lotNo, lotId, onClick }) => (
  //style={{ cursor: "pointer" }}
  <span onClick={() => onClick(lotId)}>{lotNo}</span>
);

const DisplayLotNoLink = ({ LotNos, LotIds }) => {
  const arrLotNos = LotNos.split(",");
  const arrLotIds = LotIds.split(",");

  const handleLotClick = (lotId) => {
    //const getLotId = window.btoa(lotId);
    //window.location.href = `/lotlistview/${getLotId}`;
  };

  return (
    <div>
      {arrLotNos.map((lotNo, index) => (
        <>
          <LotLink
            key={index}
            lotNo={lotNo}
            lotId={arrLotIds[index]}
            onClick={handleLotClick}
          />
          {index < arrLotNos.length - 1 && <span>, </span>}
        </>
      ))}
    </div>
  );
};

const BidderDashboard = () => {
  // eslint-disable-next-line no-unused-vars
  const [accordion, setAccordion] = useState(true);

  const { authenticated } = Auth();

  const [loading, setloading] = useState(false);
  const [userData, setUserData] = useState([]);

  const [collectionSeason, setCollectionSeason] = useState(0);
  const [itemsCollectionSeason, setItemsCollectionSeason] = useState([]);
  useEffect(() => {
    getTenderCollectionSeasonDrop();
    console.log("userData", userData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const getTenderCollectionSeasonDrop = async () => {
    await apiCallResponse(`Tender/GetTenderCollectionSeason`, "GET").then(
      (res) => {
        if (res.success) {
          setItemsCollectionSeason(res.data);
          handleCollectionSeason(res.data[0].collectionSeason);
          setloading(true);
        } else setItemsCollectionSeason([]);
      }
    );
  };
  const getNotificatinBidderList = async (collectionSeason) => {
    if (authenticated) {
      setUserData([]);

      await apiCallSPGet(
        `Dashboard/Bidder?userId=${authenticated.userId}&collectionSeason=${collectionSeason}`
      )
        .then((res) => {
          if (res.success) {
            setUserData(res.data);
            console.log("getNotificatinBidderList", res.data);
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  const handleCollectionSeason = (value) => {
    setCollectionSeason(value);
    getNotificatinBidderList(value);
  };

  const isDateInRange = (dateStr) => {
    if (dateStr != null && dateStr !== "0001-01-01T00:00:00") {
      const date = new Date(dateStr);
      const currentDate = new Date();
      const futureDate = new Date();
      futureDate.setDate(currentDate.getDate() + 7);

      // Compare dates as timestamps
      return (
        date.getTime() >= currentDate.getTime() &&
        date.getTime() <= futureDate.getTime()
      );
    } else {
      return false;
    }
  };

  const displayDetails = (lable, value) => {
    return (
      <CCol xs={12} lg={6} xxl={4} className={`d-flex align-items-center `}>
        <>
          {lable} : <CLabel className={"ml-1"}>{value}</CLabel>
        </>
      </CCol>
    );
  };

  const displayDateTime = (lable, value) => {
    //const date = formatDateTime(value);
    const date = formatDate(value);
    const isUpComming7Days = isDateInRange(value);
    return (
      <CCol xs={12} lg={6} xxl={4} className={`d-flex align-items-center `}>
        <>
          {lable} :
          <CLabel className={`ml-1 ${isUpComming7Days && "importantDate"}`}>
            {date}{" "}
            {isUpComming7Days ? (
              <CIcon
                name="cil-warning"
                style={{ color: "red", marginTop: "-0.1rem" }}
              />
            ) : (
              ""
            )}
          </CLabel>
        </>
      </CCol>
    );
  };
  return (
    <>
      <CRow>
        <CCol xs="12">
          <CCard class="">
            <CCardHeader>
                 {/* <CRow>
                                        <CCol>
                                          <div >
                                       <br></br>
                                       <marquee style={{ color: 'red', fontWeight: 'bold', fontSize: '18px', Height:'50px' }}>Important Note: Our website will undergo scheduled maintenance and will be unavailable for approximately 30 hours starting from 10th October 2025 at 11:59 PM onwards.</marquee>
                                    </div> 
                                        </CCol>
                                      </CRow> */}
              <CRow className="pt-3 ">
                <CCol>
                  {/* <h3>CCF Home</h3> */}
                  <h3>Bidder Dashboard</h3>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <SCSelect
                  CColClassName="mb-3"
                  labelname="Collection Season"
                  name="collectionSeason"
                  value={collectionSeason}
                  onChange={(e) => handleCollectionSeason(e.target.value)}
                  items={itemsCollectionSeason.map((item, key) => ({
                    value: item.collectionSeason,
                    label: item.collectionSeason,
                  }))}
                />
                <CCol xl={9} sm={6} className={"bidderDashboard"}>
                  <CLabel>Note : </CLabel>
                  <br />
                  {/* //className="importantDate" */}
                  <CLabel>
                    <CIcon
                      name="cil-warning"
                      style={{ color: "red", marginTop: "-0.1rem" }}
                    />
                    &nbsp; We will display an alert icon next to the important
                    dates for a particular tender/lot(s) if any of those dates
                    fall within the next 7 days from today.
                  </CLabel>
                </CCol>
              </CRow>
              <div id="accordion">
                {loading ? (
                  <div className="text-center mt-5">
                    <CSpinner className="spinner-grow" color="success" />
                  </div>
                ) : (
                  userData.map((item, index) => (
                    <CCard
                      className="mb-4 bidderDashboard shadow-sm"
                      key={index}
                    >
                      <CCardHeader id="headingOne">
                        {/* <CButton
                          block
                          color="link"
                          className="text-left m-0 p-0"
                          onClick={() => setAccordion(accordion === 0 ? null : 0)}
                        > */}

                        <div className="d-flex align-items-center">
                          <CRow>
                            <CCol xs={12} className="d-flex align-items-center">
                              <>
                                Tender No :
                                <h5 className="m-0 p-0 ml-1 mr-2">
                                  {item.tenderNo}
                                </h5>
                                (Lot No : {"  "}
                                <DisplayLotNoLink
                                  LotNos={item.lotNos}
                                  LotIds={item.lotIds}
                                />
                                )
                              </>
                            </CCol>
                          </CRow>
                        </div>
                      </CCardHeader>
                      <CCollapse show={accordion}>
                        <CCardBody>
                          <CRow>
                            <CCol
                              xs={12}
                              className={"d-flex align-items-center "}
                            >
                              Detail :{" "}
                              <span className="ml-1">{item.details}</span>
                            </CCol>
                            {displayDetails(
                              "Rebate",
                              item.rebate.toFixed(3) + "%"
                            )}
                            {displayDetails(
                              "Late Fee Per Day",
                              item.lateFeePerDay.toFixed(3) + "%"
                            )}
                            {displayDetails(
                              "Termination Late Fee Per Day",
                              item.terminationLateFeePerDay.toFixed(3) + "%"
                            )}
                            {displayDetails(
                              "Restoration Fee",
                              "Rs. " + item.restorationFee.toFixed(2)
                            )}

                            {displayDetails(
                              "Penalty Amount",
                              "Rs. " + item.penaltyAmount.toFixed(2)
                            )}
                            {displayDetails(
                              "Godown Rent Per Bag",
                              "Rs. " + item.godownRent.toFixed(2)
                            )}
                            {displayDateTime(
                              "Termination Up To Date",
                              item.terminationUpToDate
                            )}
                            {displayDateTime(
                              "Agreement Signed Last Date",
                              item.bidderAgreementSignedLastDate
                            )}
                            {/* {displayDateTime(
                            "Agreement Start Date ",
                            item.agreementStartDate
                          )} */}
                            {displayDateTime(
                              "First Agreement Date ",
                              item.agreementUpToDate
                            )}
                            {displayDateTime(
                              "Cheque Replacement Last Date ",
                              item.chequeReplacementLastDate
                            )}
                            {displayDateTime(
                              "Second Agreement Extension Date ",
                              item.secondExtentionDateTime
                            )}
                            {displayDateTime(
                              "First Transfer Last Date ",
                              item.firstTransferLastDate
                            )}
                            {displayDateTime(
                              "Second Transfer Start Date ",
                              item.secondTransferStartDate
                            )}
                            {displayDateTime(
                              "Second Transfer End Date ",
                              item.secondTransferEndDate
                            )}
                            {displayDateTime(
                              "Additional SD Last Date ",
                              item.additionalSDLastDate
                            )}
                            {displayDateTime(
                              "Godown Rent Payment Upto Date ",
                              item.godownRentPaymentUpToDate
                            )}
                            {displayDateTime(
                              "Godown Diff. Payment Last Date ",
                              item.godownDiffPaymentLastDate
                            )}
                            {displayDateTime(
                              "First Installment Payment Last Date ",
                              item.firstInstallmentDueDate
                            )}
                            {displayDateTime(
                              "Second Installment Payment Last Date ",
                              item.secondInstallmentDueDate
                            )}
                            {displayDateTime(
                              "Third Installment Payment Last Date ",
                              item.thirdInstallmentDueDate
                            )}
                            {displayDateTime(
                              "Fourth Installment Payment Last Date ",
                              item.fourthInstallmentDueDate
                            )}
                            {displayDateTime(
                              "Full Installment Payment Last Date ",
                              item.fullInstallmentDueDate
                            )}
                            {displayDateTime(
                              "Termination Agreement Start Date ",
                              item.terminationAgreementStartDate
                            )}
                            {displayDateTime(
                              "Termination Agreement End Date ",
                              item.terminationAgreementEndDate
                            )}
                          </CRow>
                        </CCardBody>
                      </CCollapse>
                    </CCard>
                  ))
                )}
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default BidderDashboard;
